module.exports = __webpack_public_path__ + "static/media/the-great-outdoors.6896bd3c.jpeg";